export enum ExportType {
  NO_EXPORT = 'NO_EXPORT',
  CSV = 'CSV',
  XLSX = 'XLSX',
  HTML_TABLE = 'HTML_TABLE',
  PNG = 'PNG',
}

export const EXPORT_TYPE_TEXT: any = {
  [ExportType.NO_EXPORT]: 'No Export',
  [ExportType.CSV]: 'CSV',
  [ExportType.XLSX]: 'XLSX',
  [ExportType.HTML_TABLE]: 'HTML Table',
  [ExportType.PNG]: 'PNG',
}
